import { DeepLink } from "../users/models/DeepLink";

export function clone(object: {}): any {

  return JSON.parse(JSON.stringify(object));
}

export interface IIndexer<T> {
  [propName: string]: T;
}


export function arrayToObject<T>(items: T[], key: string=null): IIndexer<T> {

  let obj :any= {}
  for (let item of items) {
    let k: any;
    if (key != null)
      k = item[ key ];
    else
      k = item;

    obj[k] = item;
  }
  return obj;

}


export function copyToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    var successful = document.execCommand('copy');
    return successful;
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
    return false;
  }
  finally {
    document.body.removeChild(textArea);
  }
}